import { faCheck, faRefresh, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, Autocomplete, Badge, Button, Checkbox, Input, Text } from '@mantine/core';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react'
import { BASE_URL } from '../../../api/EndPoints';
import { IconCaretDownFilled, IconChevronDown } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';



const ChildrenFilter = (
  {
    isInline = false,
    selectedItems, selectedMenu, filterClearAll, filterHeader,
    handleChipClear, handleFilterChange, handleOnApply, setSelectedItems,
    handleColorClick, filteredSearch, variants, checkboxChange, checkboxChangeCollection, filters, allCollection, collectid, setCollectId, setMenuOpened,
  }

) => {
  const [clearHide, setClearHide] = useState({});
  const navigate = useNavigate();
  const handleNavigate = (collection) => {
    navigate('/collections', {
      state: { collectionId: collection.collectionId, fullCollection: collection },
    });
    setMenuOpened(false);

  };


  const [error, setError] = useState('');
  const renderCollections = (collections) => {
    const collectionList = Array.isArray(collections) ? collections : (collections?.collections || collections?.child || allCollection || []);
    if (!collectionList || !Array.isArray(collectionList)) return null;
    return collectionList.map((collection, cIndex) => (
      <div key={`collection-${cIndex}`} style={{ padding: '6px 0' }}>
        <Checkbox
          color='#8BC54F'
          label={collection.collectionName || collection.name}
          checked={collectid === collection.collectionId}
          onChange={(e) => {
            if (collectid === collection.collectionId) {
              setCollectId();
            } else {
              if (location?.pathname === '/collections') {
                setSelectedItems(collection);
                setMenuOpened(false);
              } else {
                handleNavigate(collection);
                setClearHide(collection);
                setSelectedItems(collection);
                checkboxChangeCollection(e, collection);
              }
            }
          }}
        />
      </div>

    ));
  };

  const getAllItemNames = (itemList) => {
    let names = [];
    itemList?.forEach(i => {
      if (i.name) names.push(i.name);
      if (i.child && i.child.length > 0) {
        names = names.concat(getAllItemNames(i.child));
      }
    });
    return names;
  };

  const getSelectedCountRecursive = (node) => {
    if (!node) return 0;
    const categoryName = selectedMenu?.name || selectedMenu?.collectionName;
    const selectedList = selectedItems[categoryName] || [];
    let count = 0;

    const isSelfSelected = selectedList.some(
      s => (s.categoryId && node.categoryId && s.categoryId === node.categoryId) ||
        (s.id && node.id && s.id === node.id)
    );
    if (isSelfSelected) count += 1;

    if (node.child && node.child.length > 0) {
      node.child.forEach(childNode => {
        count += getSelectedCountRecursive(childNode);
      });
    }

    return count;
  };

  const renderTreeItems = (items, depth = 0) => {
    if (!items || items.length === 0) return null;
    const primaryColor = "var(--primary)";

    return (
      <div className={`tree-items-container depth-${depth === 0 ? '0' : 'sub'}`}>
        {items.map((item, index) => {
          const hasChildren = item.child && item.child.length > 0;
          const childSelectedCount = hasChildren ? getSelectedCountRecursive(item) : 0;

          const isChecked = selectedItems[selectedMenu.name]?.some(selectedItem => selectedItem.categoryId === item.categoryId);

          const isTopParentHeader = (depth === 0 && hasChildren);
          const isSubGroupHeader = (depth > 0 && hasChildren);

          return (
            <div key={`${depth}-${index}-${item.categoryId || item.name}`} className="tree-item-wrapper">
              {isTopParentHeader ? (
                <div className={`top-parent-header ${index > 0 ? 'next-item' : ''}`}>
                  {item.name}
                  {childSelectedCount > 0 && (
                    <span className="badge-active-children inline-badge">
                      {childSelectedCount}
                    </span>
                  )}
                </div>
              ) : isSubGroupHeader ? (
                <div
                  className="sub-group-header"
                  style={{ paddingLeft: `${depth * 8}px` }}
                >
                  {item.name}
                  {childSelectedCount > 0 && (
                    <span className="badge-active-children inline-badge-sub">
                      {childSelectedCount}
                    </span>
                  )}
                </div>
              ) : (
                <div
                  className="leaf-checkbox-wrapper"
                  style={{ paddingLeft: `${Math.max(depth, 2) * 8}px` }}
                >
                  {selectedMenu.name === 'Fabric Content' && isChecked ? (
                    <div>
                      <Checkbox
                        className={`tree-item-checkbox ${isChecked ? 'checked' : ''}`}
                        color={isChecked ? primaryColor : 'inherit'}
                        checked={isChecked}
                        label={item.name}
                        onChange={(event) => checkboxChange(event, item)}
                      />
                      <div className="metrics-wrapper">
                        {metrics({
                          filterHeader: selectedMenu.name,
                          value: filters[filterHeader]?.[item.categoryId] || { min: null, max: null },
                          onChange: (newValue) => handleFilterChange(filterHeader, newValue, item.categoryId),
                          item: item,
                          onApply: (range) => handleOnApply(filterHeader, range, item),
                        })}
                      </div>
                    </div>
                  ) : (
                    <Checkbox
                      className={`tree-item-checkbox ${isChecked ? 'checked' : ''}`}
                      color={isChecked ? primaryColor : 'inherit'}
                      checked={isChecked}
                      label={item.name}
                      onChange={(event) => {
                        if (selectedMenu.name !== 'Fabric Content') {
                          checkboxChange(event, item);
                        } else {
                          handleOnApply(selectedMenu.name, { min: 0, max: 100 }, item);
                        }
                      }}
                    />
                  )}
                </div>
              )}

              {/* Render Sub-Children Recursively */}
              {hasChildren && (
                <div className="tree-sub-children-wrapper">
                  {renderTreeItems(item.child, depth + 1)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const metrics = ({ filterHeader, units, value = { min: '', max: '' }, onChange, onApply }) => {
    const minValue = value.min ?? '';
    const maxValue = value.max ?? '';


    const handleApply = () => {
      setError('');
      if (filterHeader === "Fabric Content") {
        if (Number(maxValue) < Number(minValue)) {
          setError("Max value cannot be less than Min value or greater than 100.");
          return;
        }
      } else {
        if (Number(minValue) > Number(maxValue)) {
          setError("Min value cannot be greater than Max value.");
          return;
        }
      }

      onApply({ min: minValue, max: maxValue });
    };

    return (
      <div className="metrics-container" style={{ margin: '1rem 0' }}>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <Input
            size="xs"
            type="number"
            placeholder="Min"
            value={minValue}
            onChange={(e) => onChange({ ...value, min: e.target.value })}
            style={{ width: '70px' }}
          />
          <span>-</span>
          <Input
            size="xs"
            type="number"
            placeholder="Max"
            value={maxValue}
            onChange={(e) => onChange({ ...value, max: e.target.value })}
            style={{ width: '70px' }}
          />
          {units && <span style={{ fontSize: '0.8rem', color: '#666' }}>{units}</span>}
          <Button size="xs" variant="light" onClick={handleApply}>
            Apply
          </Button>
        </div>
        {error && (
          <Text color="red" size="xs" style={{ marginTop: '0.25rem' }}>
            {error}
          </Text>
        )}
      </div>
    );
  };



  const Moq = ({ filterHeader, value = { moq: '' }, onChange, onApply }) => {
    const moqValue = value.moq ?? '';

    const handleApply = () => {
      onApply({ moq: moqValue });
    };

    return (
      <div className="metrics-container" style={{ margin: '1rem 0' }}>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <Input
            size="xs"
            type="number"
            placeholder="Moq"
            value={moqValue}
            onChange={(e) => onChange({ ...value, moq: e.target.value })}
            style={{ width: '70px' }}
          />

          <Button size="xs" variant="light" onClick={handleApply}>
            Apply
          </Button>
        </div>

      </div>)
  };



  return (
    <div>
      <div className={isInline ? 'children-inline-container' : 'children-standalone-container'}>
        {
          selectedMenu?.child?.length === 0 ?
            <div>
              <div>No filters are available for that search value...</div>
            </div>
            :
            selectedMenu?.child && selectedMenu.group === 'BASIC' ? (
              <div>
                {renderTreeItems(selectedMenu.child)}
              </div>
            ) : selectedMenu?.name === 'MOQ' && selectedMenu.group === 'BASIC' ? (
              Moq({
                filterHeader,
                value: filters[filterHeader] || { moq: null },
                onChange: (newValue) => handleFilterChange(filterHeader, newValue),
                onApply: (range) => handleOnApply(filterHeader, range),
              })
            ) : selectedMenu?.name !== 'MOQ' && selectedMenu.group === 'BASIC' ? (
              metrics({
                filterHeader,
                units: filterHeader === 'Width' ? 'inch' :
                  filterHeader === 'Weight' ? 'gsm' :
                    filterHeader === 'Price' ? <span>&#8377;</span> : '',
                value: filters[filterHeader] || { min: null, max: null },
                onChange: (newValue) => handleFilterChange(filterHeader, newValue),
                onApply: (range) => handleOnApply(filterHeader, range),
              })
            ) : selectedMenu?.name === 'Colour' ? (
              <div className="filter-colors-grid">
                {variants
                  .filter(variant => variant?.name === selectedMenu?.name)
                  .map((variant, index) =>
                    variant.child.map((child, childIndex) => (
                      <div className="color-item" key={childIndex} onClick={() => handleColorClick(child)} style={{ cursor: 'pointer' }}>
                        <div className="filter-color-cell" style={{
                          background: child.hexaColorCode,
                          boxShadow: `1px 1px 1px 1px ${child.hexaColorCode}`,
                          border: child.hexaColorCode === '#FFFFFF' || child.name === 'White' ? '1px solid silver' : `1px solid ${child.hexaColorCode}`
                        }}>
                          {selectedItems[selectedMenu.name]?.some(color => color.id === child.id) && (
                            <FontAwesomeIcon icon={faCheck} className="far fa-check" />
                          )}
                          <i style={{ color: child.hexaColorCode }}></i>
                        </div>
                        <div className="color-name">{child.name}</div>
                      </div>
                    ))
                  )}
              </div>
            ) : selectedMenu?.name === 'Solid / Pattern' ? (
              <div className="filter-colors-grid">
                {variants
                  .filter(variant => variant?.name === selectedMenu?.name)
                  .map((variant, index) =>
                    variant.child.map((child, childIndex) => (
                      <div className="color-item" key={childIndex} onClick={() => handleColorClick(child)} style={{ cursor: 'pointer' }}>
                        <img src={`${BASE_URL.replace('/api', '')}${child.image}?time=${Date?.now()}`} style={{ width: '60px', height: '30px' }} />
                        <div className="color-name">{child.name}</div>
                      </div>
                    ))
                  )}
              </div>

            ) : <div>
              {selectedMenu?.group === 'COLLECTIONS' || selectedMenu?.name === 'Collections' ? renderCollections(selectedMenu) : selectedMenu?.child ? renderTreeItems(selectedMenu.child) : renderCollections(selectedMenu)}
            </div>
        }
      </div>
    </div>
  );
}

export default ChildrenFilter